/**
 * `returnTo` — retour post-authentification (spec games/motus-daily §9.1, ADR 0012).
 *
 * Le funnel invité envoie vers `/signup?returnTo=/motus-daily` (ou `/login?…`) ;
 * après succès, la page d'auth redirige vers ce chemin AU LIEU de la destination
 * par défaut. ANTI OPEN-REDIRECT : seuls des chemins INTERNES sont acceptés —
 * tout le reste (URL absolue, protocole implicite `//`, antislash que les
 * navigateurs normalisent en `/`) est rejeté et retombe sur le défaut.
 */

/** Valide un `returnTo` : chemin interne (`/…`) ou `null` (défaut). */
export function safeReturnTo(raw: string | null | undefined): string | null {
  if (!raw) return null;
  if (!raw.startsWith('/')) return null; // rejette « https://evil », « evil », « javascript: »…
  if (raw.startsWith('//')) return null; // rejette « //evil » (URL protocol-relative)
  if (raw.includes('\\')) return null; // rejette « /\evil » (normalisé « //evil » par les navigateurs)
  return raw;
}

/** Construit `/login?returnTo=…` ou `/signup?returnTo=…` (paramètre encodé). */
export function withReturnTo(path: '/login' | '/signup', returnTo: string): string {
  return `${path}?returnTo=${encodeURIComponent(returnTo)}`;
}
